import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { addNotification, removeNotificationByErrorObject } from './notifications.actions';
import { delay, map, of, switchMap } from 'rxjs';

const ERRORS_REMOVE_TIMEOUT = 30000;

@Injectable()
export class NotificationsEffects {
  public addNotification$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(addNotification),
      switchMap(action => {
        return of(action).pipe(
          delay(ERRORS_REMOVE_TIMEOUT),
          map(() => removeNotificationByErrorObject({ errorObject: action })),
        );
      }),
    )
});

  constructor(
    private _actions$: Actions,
  ) {}
}
